export default {
  common: {
    siteName: '${webTitle}用户中心',
    units: {
      vCoreSingle: '核',
      vCoreComplex: '核',
    },
    list: {
      searchButton: '搜索',
      location: '所在区域',
      areaAll: '全部',
      columnAction: '操作',
      purchase: '购买',
    },
    modal: {
      charge: '费用',
      done: '完成',
      confirm: '确定',
      cancel: '取消',
      delete: '删除',
      pay: '支付'
    },
    monthUnit: '个月',
    yearUnit: '年',
    singleMonth: '月',
    periodSelect: {
      '1h': '1 小时',
      '1d': '1 天',
      '1w': '1 周',
      '1m': '1 个月',
    },
    // 付款组件
    payComp: {
      balance: '余额',
      methods: {
        header: '付款方式：',
        unionPay: '银联支付',
        paypal: 'PayPal',
        alipay: '支付宝',
        wechatPay: '微信支付',
        strip: 'Strip',
        creditCard: '信用卡'
      },
      addPaymentMethod: '添加付款方式',
      expires: 'Expires',
      default: 'Default',
      expiresSoon: 'Expiring soon',
      password: {header: '密码：', placeholder: '请输入登录密码'}
    },
    // 顶栏
    topBar: {
      accountBalance: '账户余额',
      addFunds: '充值',
      billingHistory: '账单历史',
      orders: '订单',
      accountId: '账号 ID',
      logout: '退出登录'
    },
    message : {
      warning: '警告',
      ok: '好的',
      sessionExpired: '会话已过期，请重新登录！',
      requestExpired: '请求已过期，请重新登录！',
      logoutSuccess: '登出成功'
    },
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh-CN/common.js